export default __webpack_public_path__ + "static/media/ib_doc.c6747ca5.svg";